// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-too-long-url',
    standalone: false,
    template: `
        <strong translate>URL:</strong> <span>{{ seo.content }}</span>
    `,
})
export class SeoInformationTooLongUrlComponent {
    @Input() seo: any;
}
